// External Imports
import { useContext} from "react";
import { UtilityContext } from "../../context/util-context";
import { MdPerson } from "react-icons/md";

// Internal Imports
import ImageSelector from "./ImageSelector";

/** ========================================================================
 * * PersonCard Component
 * This component renders card to display a person's information.
 * ========================================================================== */

export default function PersonCard({
    label,
    name,
    secondary, 
    image,
    loading,
    link
}) {
  //Load Context
  const { navigate } = useContext(UtilityContext);

  /* ====================== CLICK HANDLER ====================== */
  const clickHandler = (e) => {
    if (link) navigate(link, e);
  };

  return (
    <div
      onClick={(e) => clickHandler(e)}
      className={`flex items-center space-x-4 ${ link ? "clickable" : ""}`}
    >
      <ImageSelector
        image={image}
        loading={loading}
        classes="w-16 h-16 rounded-lg"
        imageClasses="object-cover w-16 h-16"
      >
        <MdPerson className="text-4xl text-yellow-600" />
      </ImageSelector>
      {loading ? (
        <div className="grid w-1/2 gap-2">
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
          <p className="h-4 rounded-sm bg-stone-700 animate-pulse" />
        </div>
      ) : (
        <div className="grid">
          <p className="font-semibold text-stone-400">{label}</p>
          <p className="text-base">{name}</p>
          <p className="text-stone-400">{secondary}</p>
        </div>
      )}
    </div>
  );
}
